import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import type { Workspace } from '../../types/content';
export function WorkspaceSurfaces({
  workspace
}: {
  workspace: Workspace;
}) {
  const [first, second] = workspace.surfaces;
  return <section className="bg-white/50 py-20 md:py-28" data-id="element-535" data-mp="2hy4r1ywkaxh1">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-536" data-mp="2hwju62mrz2g0">
        <SectionHeader title={`${first.name} and ${second.name}.`} body="Two views of the same environment. Each person sees the tasks and records that belong to their role." data-id="element-537" data-mp="238yruaxq5795" />
        <div className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-538" data-mp="1u9lh7exv6cmu">
          {workspace.surfaces.map((s, i) => <article key={s.name} className={`flex flex-col rounded-[28px] p-7 md:p-9 ${i === 0 ? 'glass' : 'bg-ink text-white'}`} data-id="element-539" data-mp="1ybferecrj0is" data-mpi={i}>
              <p className={`text-sm font-medium ${i === 0 ? 'text-accent' : 'text-white/60'}`} data-id="element-540" data-mp="1kbecpvkrhn1q">{s.audience}</p>
              <h3 className="mt-2 text-2xl font-semibold tracking-tight" data-id="element-541" data-mp="1pbsfay3lg4sd">{s.name}</h3>
              <p className={`mt-3 text-[15px] leading-relaxed ${i === 0 ? 'text-ink-soft' : 'text-white/75'}`} data-id="element-542" data-mp="2q3mxodmj7gv3">{s.body}</p>
              <ul className="mt-auto space-y-2.5 pt-7" data-id="element-543" data-mp="2l8ps5gognpmy">
                {s.items.map(item => <li key={item} className="flex items-center gap-2.5 text-[15px]" data-id="element-544" data-mp="2u71p00fx7jnu">
                    <CheckIcon className={`h-4 w-4 shrink-0 ${i === 0 ? 'text-accent' : 'text-white/60'}`} aria-hidden="true" data-id="element-545" data-mp="2u4ymigxkzy28" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}